import React, { useState } from "react";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Container,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Email } from "@mui/icons-material";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import AppButton from "../utils/Appbutton";
import branding from "../config/branding";
import colors from "../config/colors";
import footer from "../utils/footer";
import { requestPasswordReset } from "../services/auth";

const validationSchema = Yup.object({
  email: Yup.string().email("Email inválido").required("Email é obrigatório"),
});

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [fieldError, setFieldError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    try {
      await validationSchema.validate({ email });
      setFieldError("");
      setLoading(true);

      const resetUrl = `${window.location.origin}/reset-password`;
      const response = await requestPasswordReset({ email, resetUrl });
      setSuccess(
        response?.message ||
          "Se o email existir, enviaremos um link para redefinir a senha.",
      );
      setEmail("");
    } catch (err) {
      if (err?.name === "ValidationError") {
        setFieldError(err.message);
      } else {
        setError(
          err?.response?.data?.message ||
            "Não foi possível enviar o email de recuperação.",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={6} sx={{ borderRadius: "12px", overflow: "hidden" }}>
          <Box
            sx={{
              background: "linear-gradient(135deg, #9c27b0 0%, #757575 100%)",
              color: "white",
              padding: 3,
              textAlign: "center",
            }}
          >
            <Box
              component="img"
              src={branding.logo}
              alt="Logo"
              sx={{ height: 180, width: 180, borderRadius: "15%" }}
            />
          </Box>

          <CardContent sx={{ padding: 4 }}>
            <Stack spacing={2}>
              <Typography variant="h5" fontWeight={700} textAlign="center">
                Recuperar senha
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
              >
                Informe o seu email para receber o link de alteração de senha.
              </Typography>

              {error && <Alert severity="error">{error}</Alert>}
              {success && <Alert severity="success">{success}</Alert>}

              <form onSubmit={handleSubmit}>
                <Stack spacing={3}>
                  <TextField
                    fullWidth
                    name="email"
                    label="Email"
                    type="email"
                    variant="filled"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    error={Boolean(fieldError)}
                    helperText={fieldError}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email sx={{ color: colors.secondary }} />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <AppButton
                      type="submit"
                      valueText="Enviar link"
                      loading={loading}
                    />
                  </Box>
                </Stack>
              </form>

              <Typography variant="body2" textAlign="center">
                <Link
                  to="/"
                  style={{ color: "#9c27b0", textDecoration: "none" }}
                >
                  Voltar ao login
                </Link>
              </Typography>
            </Stack>
          </CardContent>
        </Card>
        {footer()}
      </Container>
    </Box>
  );
};

export default ForgotPasswordScreen;
